import PropTypes from "prop-types"

import { showHolidayRma } from "helpers/holiday"
// import { showHolidayRma, holidayRmaDates } from "helpers/holiday"

import { MsgWrap } from "./components"

const HolidayMsg = ({ style }) => (
  <>
    {showHolidayRma() && (
      <MsgWrap {...style}>
        Given the high demand during the holiday season, we anticipate that
        repairs or returns may take longer than usual. If your repair or return
        deadline falls within this period, we will adjust the date accordingly.
        {/* Please note: In order to focus on customer{" "}
        {sl.config.guaranteed_holiday} orders, we will pause processing {type}{" "}
        between {holidayRmaDates.start} and {holidayRmaDates.end}. */}
      </MsgWrap>
    )}
  </>
)

HolidayMsg.propTypes = {
  style: PropTypes.object,
}

export default HolidayMsg
